import initialize_external_links from "../../shared/utils/initialize_external_links";

export default function() {
  const text =  "Das von Ihnen gewählte Angebot ist nicht Teil von Surgeon Talk, sondern wird von einem externen Anbieter bereitgestellt. Mit diesem Link verlassen Sie das Angebot von Surgeon Talk auf surgeontalk.bdc.de und gelangen zum gewählten Angebot.<p><strong>Weiter zum externen Angebot und Surgeon Talk verlassen?</strong></p>"
  initialize_external_links(text);
}
